require('file-loader?name=[name].[ext]!./BonnerCountyLogo-favicon.png');
require('file-loader?name=[name].[ext]!./BonnerCountyLogo-75.png');
require('file-loader?name=[name].[ext]!./BonnerCountyLogo-45.png');
require('file-loader?name=[name].[ext]!./info.svg');
// require('file-loader?name=[name].[ext]!./BodyHTML.html');
require('file-loader?name=[name].[ext]!./Record_Detail.html');
require('file-loader?name=[name].[ext]!./index.css');
import './index.css';
import * as query from "@arcgis/core/rest/query";

const mainBodyDiv = document.getElementById("mainBodyDiv");

LoadPage();

async function LoadPage() {
    const fetchHtml = await fetch("BodyHTML.html", { cache: "reload" });
    const htmlResponse = await fetchHtml.text();
    mainBodyDiv.innerHTML = htmlResponse;

    const searchButton = document.getElementById("search-button");
    const searchBox = document.getElementById("search-box");

    searchBox.addEventListener("keyup", (e) => { // keyup will capture textbox after backspace is finished
        ////https://dev.to/dailydevtips1/javascript-if-shorthand-without-the-else-13ch
        (e.key == "Enter") && searchButton.click();
    });
    searchBox.addEventListener("input", (e)=>{
        //// https://www.w3schools.com/c/c_conditions_short_hand.php
        (searchBox.value.trim() == "") ? searchButton.disabled = true :  searchButton.disabled = false;
    });

    searchButton.addEventListener("click", async (e) => {
        let val = searchBox.value.trim().toUpperCase();

        //// https://stackoverflow.com/questions/3884632/how-to-get-the-last-character-of-a-string
        //// https://stackoverflow.com/questions/952924/how-do-i-chop-slice-trim-off-last-character-in-string-using-javascript
        //// https://www.w3schools.com/c/c_conditions_short_hand.php
        (val.slice(-1) == "A") ? val = val.slice(0, -1) : val;
        
        const queryResults = await query.executeQueryJSON("https://cloudgis.bonnercountyid.gov/server/rest/services/Hosted/AssessorDataFile/FeatureServer/0", {
            where: `pin like '%${val}%' or primaryownername like '%${val}%' or secondaryownername like '%${val}%' or owner1 like '%${val}' or owner2 like '%${val}%' or owner3 like '%${val}%' or owner4 like '%${val}%' or owner5 like '%${val}%' or owner6 like '%${val}%' or situs like '%${val}%' or legaldescription like '%${val}%'`,
            outFields: ["lrsn", "pin", "neighborhood", "primaryownername", "secondaryownername", "situs", "legaldescription", "propclsdescr", "taxcodearea", "cybillnum", "cytaxbilled", "grossassessedvalue", "exemptionsgranted", "netassessedvalue", "landvalue", "improvementsvalue", "categories", "totalfinishedarea", "garbasearea", "cpbasearea", "acreage", "deed1", "deed2", "deed3", "deed4", "deed5", "housetype", "reviewyear", "taxyear"]
        });

        if(queryResults.features.length == 0){
            alert("No records found. Please modify the search.")
        }
        if (queryResults.features.length > 0) {
            CreateResultsTable(queryResults.features);
        }

    });

}

function CreateResultsTable(features) {
    const resultsTable = document.getElementById("resultsTable");
    resultsTable.innerHTML = "";

    const totalNum = document.getElementById("total-features-found");
    totalNum.innerHTML = `Records found: ${features.length}`;

    features.forEach((feature) => {
        const attrs = feature.attributes;
        // console.log(attrs);

        const trHeader = resultsTable.insertRow();
        trHeader.className = "tr-header";
        trHeader.innerHTML = `
            <td class='td-header'><strong>${attrs.pin}</strong></td>
            <td class='td-header'><strong>${attrs.primaryownername}</strong></td>`;

        const trInfo = resultsTable.insertRow();
        trInfo.className = "tr-info";
        trInfo.innerHTML = `
            <td class='td-info'>
                <button class='record-button' lrsn='${attrs.lrsn}'>View Record</button>
                <br><br>
            </td>
            <td class='td-info'>
                <strong>Property Address:</strong> ${attrs.situs}
                <br>
                <strong>Legal Description:</strong> ${attrs.legaldescription}
                <br><br>
            </td>`;

        resultsTable.append(trHeader);
        resultsTable.append(trInfo);
    });

    const viewRecordButtons = document.querySelectorAll("button[lrsn]");
    viewRecordButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            const lrsn = Number(e.target.getAttribute("lrsn"));
            for(let i = 0; i < features.length; i++){
                const attrs = features[i].attributes;
                // console.log(i);
                if(attrs.lrsn == lrsn){
                    viewRecordClick(attrs);
                    break;
                }
            }
        });
    });
}

function viewRecordClick(attrs){
    // console.log(attrs);
    sessionStorage.setItem("record", JSON.stringify(attrs));
    window.open("Record_Detail.html");
}